import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Heart, Star, CheckCircle } from 'lucide-react';
import { needs, motivations, aspirations } from '../../../data/comprehensiveFindingsData';
import './NeedsMotivationsAspirations.css';

const NeedsMotivationsAspirations: React.FC = () => {
  const columns = [
    {
      id: 'needs',
      title: 'Needs',
      subtitle: 'What the community requires',
      icon: BookOpen,
      data: needs,
      color: 'green',
      gradient: 'linear-gradient(135deg, rgba(32, 201, 151, 0.1) 0%, rgba(32, 201, 151, 0.05) 100%)',
    },
    {
      id: 'motivations',
      title: 'Motivations',
      subtitle: 'What drives them forward',
      icon: Heart,
      data: motivations,
      color: 'yellow',
      gradient: 'linear-gradient(135deg, rgba(253, 214, 42, 0.1) 0%, rgba(253, 214, 42, 0.05) 100%)',
    },
    {
      id: 'aspirations',
      title: 'Aspirations',
      subtitle: 'What they hope to achieve',
      icon: Star,
      data: aspirations,
      color: 'purple',
      gradient: 'linear-gradient(135deg, rgba(147, 51, 234, 0.1) 0%, rgba(147, 51, 234, 0.05) 100%)',
    },
  ];

  return (
    <div className="tmf-needs-motivations-aspirations">
      <div className="tmf-nma-grid">
        {columns.map((column, columnIndex) => {
          const Icon = column.icon;

          return (
            <motion.div
              key={column.id}
              className={`tmf-nma-column nma-${column.color}`}
              style={{ background: column.gradient }}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.7,
                delay: columnIndex * 0.2,
                ease: 'backOut',
              }}
            >
              {/* Column header */}
              <div className="tmf-nma-header">
                <div className="tmf-nma-icon-wrapper">
                  <Icon className="tmf-nma-icon" size={32} />
                </div>
                <h4 className="tmf-nma-title">{column.title}</h4>
                <p className="tmf-nma-subtitle">{column.subtitle}</p>
              </div>

              {/* Column content */}
              <div className="tmf-nma-content">
                {column.data.map((item, itemIndex) => (
                  <motion.div
                    key={itemIndex}
                    className="tmf-nma-item"
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{
                      duration: 0.5,
                      delay: columnIndex * 0.2 + itemIndex * 0.1,
                    }}
                  >
                    <h5 className="tmf-nma-item-title">{item.title}</h5>
                    <ul className="tmf-nma-item-list">
                      {item.items.map((detail, detailIndex) => (
                        <li key={detailIndex} className="tmf-nma-item-detail">
                          <CheckCircle className="tmf-nma-check-icon" size={14} />
                          <span>{detail}</span>
                        </li>
                      ))}
                    </ul>
                    <span className="tmf-nma-theme-ref">Theme {item.themeRef}</span>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};

export default NeedsMotivationsAspirations;
